import React from 'react';
import {getEnvironment} from '../../app/App';
import {InfoWindow, Marker, GoogleApiWrapper} from 'google-maps-react';
import MapLocation from './MapLocation';

var confCurrent = getEnvironment();

class MapContainer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      companies: [],
      directories: [],
      tokens: [],
      actions: [],
      contacts: [],
      logos: [],
      apiKeyMaps: '',
      confCurrent: '',
      location: '',
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      showMeInfo: false,
      activeMeMarker: {},
      currentLocation: {
        lat: 0,
        lng: 0,
        zoom: 11
      }
    }
  }

  onMeMarker = (props, marker, e) =>
      this.setState({
        selectedPlace: props,
        activeMeMarker: marker,
        showMeInfo: true,
      }
    );

    onMeClose = props => {
      if (this.state.showingInfoWindow) {
        this.setState({
          showInfoMe: false,
          activeMeMarker: null
        });
      }
    };

  componentDidMount(){
    this.getCompaniesList();
    this.getActionsList();
    this.getSocial();
    this.getToken();
    this.getPhoneCall();
    let that = this;
    navigator.geolocation.getCurrentPosition(function(position) {
        //console.log("Latitude is :", position.coords.latitude);
        //console.log("Longitude is :", position.coords.longitude);
        //console.log("position",position)

        that.setState({
          currentLocation: {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            zoom: 15
          }
        });
      });

  }


  getCompaniesList () {
    console.log('consultando companis');
    const axios = require('axios');
    var confCurrent = getEnvironment();
    var datos = new FormData();
    let that = this;
    axios.post(confCurrent.home + 'a/company/list/get/' + Date.now(), datos)
    .then(function (response) {
      console.log("response companies", response);
      if(response.data.data.Companis != null && response.data.data.Companis !== ''){
        that.setState({companies: response.data.data.Companis, loading: false});
      }else{
        that.setState({companies: [], loading: false});
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  getActionsList() {
   console.log('consultando actions');
    const axios = require('axios');
    var confCurrent = getEnvironment();
    var datos = new FormData();
    let that = this;
    axios.post(confCurrent.home + 'a/actions/get/all/' + Date.now(), datos)
    .then(function (response) {
      console.log("response actions", response);
      if(response.data.data.Actions != null && response.data.data.Actions !== ''){
        that.setState({actions: response.data.data.Actions, loading: false});
      }else{
        that.setState({actions: [], loading: false});
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }


    getSocial() {
        const axios = require('axios');
        var datos = new FormData();
        let that = this;
        var confCurrent = getEnvironment();
        axios.post(confCurrent.home + 'a/contacts/get/all/' + Date.now(), datos)
        .then(function (response) {
          console.log("response contacts", response);
          if(response.data.data.Contacts != null && response.data.data.Contacts !== ''){
            that.setState({contacts: response.data.data.Contacts, loading: false});
          }else{
            that.setState({contacts: [], loading: false});
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      }


  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      showingInfoCompany: true
    }
  );


  onClose = props => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  };


  getCompanyLocation() {
    var confCurrent = getEnvironment();
    const companyLocation = [];
    for(var x=0;x < this.state.companies.length;x++){
      const company = this.state.companies[x];
      this.getCompanyLogo(company.idCompany);
      this.getCompanyRedirect(company.idCompany);
     // this.getPhoneCall(company.idCompany);

      var urlMarker = confCurrent.home + 'assets/images/' + company.urlIcon;
      const icon = { url: urlMarker,
                    scaledSize: {width: 36, height: 41}
                    };

       companyLocation.push(
         <Marker
            position={{ lat: company.latitude, lng: company.longitude}}
            name = {company.idCompany}
            icon = {icon}
            onClick={this.onMarkerClick}
            title = {company.nameBusiness}
          />
        );
      }
      return companyLocation;
    }


    getToken(){
      const axios = require('axios');
      var datos = new FormData();
      let that = this;
      var confCurrent = getEnvironment(this.state.idDirectory);
      axios.post(confCurrent.home +'a/tokens/get/' + Date.now(), datos)
      .then(function (response) {
        console.log("response tokens",response);
        if(response.data.data.Tokens != null && response.data.data.Tokens !== ''){
          that.setState({tokens: response.data.data.Tokens, loading: false});
        }else{
          that.setState({tokens: [], loading: false});
        }

      })
      .catch(function (error) {
        console.log(error);
      });
    }


    getCompanyRedirect(idCompany){
        const companyName = [];
        for(var x=0;x < this.state.tokens.length;x++){
            const name = this.state.tokens[x];
            if (name.idCompany === idCompany) {
              companyName.push(
                <a href={"https://rapidiux.com/" + name.token +"/"+ name.shortNameCompany} className="text-center"><p className="text-inf">Ver menú...</p></a>
               );
             }

         }
      return companyName;
      }


    getActionsByDirectory(idCompany) {
      const actionsDirectory = [];
      for(var x=0;x < this.state.actions.length;x++){
        const action = this.state.actions[x];
        if(action.idCompany === idCompany) {

          var confCurrent = getEnvironment(this.state.idDirectory);
          var icon = 'check.png';
          var tg = "_blank";
          const s = {width: '20px' , height: '20px'};

          if (action.subType == 1) {

            if (action.idStatus == 1) {
              if (action.description == '' || action.description == null) {
                icon = 'nocheck.png';
              }
          } else if (action.idStatus == 2) {
                icon = 'nocheck.png';
            }

              const url = action.urlIcon;
              const string1 = "door";
              const string2 = "moto";
              const string3 = "rapidiux";

              if ( (url.includes(string1)) ||  (url.includes(string2)) || (url.includes(string3)) ) {
                actionsDirectory.push(
                    <div className="row text-left">
                      <p className="float-left text-left directory-text">
                        <img src = {confCurrent.home + 'assets/images/' + action.urlIcon + icon} alt="" style={s}/>
                        <small> {action.description} </small>
                      </p>
                    </div>);

              } else {
                  actionsDirectory.push(
                       <div className="row text-left">
                         <p className="float-left text-left directory-text">
                           <img src = {confCurrent.home + 'assets/images/' + action.urlIcon + icon} alt="" style={s}/>
                           <small> {action.description} </small>
                         </p>
                       </div>);
              }

          } else if(action.subType == 2) {

              if (action.description  === '' || (action.urlRedirect === null || action.urlRedirect === '#')) {
                  icon = 'nocheck.png';
                  tg = "_self";
              }

              actionsDirectory.push(
                   <div className="row text-left">
                      <p className="float-left directory-text">
                      <a href={action.urlRedirect} target={tg}>
                        <img src={confCurrent.home + "assets/images/" +action.urlIcon + icon}  alt="" style={s}/> <small> {action.description}</small>
                      </a>
                      </p>
                    </div>);
            } else if (action.subType == 4){
                actionsDirectory.push(
                     <div className="row text-left">
                        <p className="float-left directory-text">
                        <a href={action.urlRedirect}>
                          <img src={confCurrent.home + "assets/images/" +action.urlIcon + icon}  alt="" style={s}/> <small> {action.description}</small>
                        </a>
                        </p>
                      </div>);
            }
          }
      }
      return actionsDirectory;
    }

  getCompanyLogo(idCompany){
      const companyLogo = [];
      for(var x=0;x < this.state.companies.length;x++){
          const logo = this.state.companies[x];
          if (logo.idCompany === idCompany) {
            companyLogo.push(
                <img className="image-map" src={confCurrent.home + "assets/images/" + logo.logoBusiness + 'map.jpg'} alt={logo.nameBusiness} key={logo.idCompany}/>
             );
           }
       }
    return companyLogo;
    }


     getContactsByDirectory(idCompany){
        const contactsDirectory = [];
        for(var x=0;x < this.state.contacts.length;x++){
          const contact = this.state.contacts[x];

          if(contact.idCompany === idCompany) {
            var confCurrent = getEnvironment(this.state.idDirectory);
            var icon = 'check.png';
            var tg = "_blank";
            const s = {width: '22px' , height: '22px'};

            if (contact.urlRedirect === '#' || contact.urlRedirect === '') {
                 icon = 'nocheck.png';
                 tg = "_self";
            }

           contactsDirectory.push(
                <div  className="col-4 col-sm-4 col-md-4">
                  <a href={contact.urlRedirect} target={tg}>
                    <span><img src={confCurrent.home + "assets/images/" +contact.urlIcon + icon}  className="mx-auto d-block"  alt="" style={s}/></span>
                  </a>
                </div>
            );
          }
        }
        return contactsDirectory;
      }

      getMarker = () => {
          const marker = [];
          const value = 999;
          const urlMarker = confCurrent.home + 'assets/images/icons/person_icon.png';
          const icon = { url: urlMarker, scaledSize: {width: 45, height: 50}};
          if (this.state.currentLocation.lat != 0) {
               marker.push(
                    <Marker
                        onClick={this.onMeMarker}
                        title={'Ubicación actual'}
                        icon = {icon}
                        zIndex = {value}
                    />
                );
                this.getZoom();
           }
        return marker;
      }

      getZoom = () => {
          if (this.state.currentLocation.lat !== 0) {
            // console.log("lat in getZoom: ", this.state.currentLocation.lat);
               var zoom = 14;
           }
          return zoom;
      }



      getPhoneCall(idCompany) {
          const phoneInfo = [];
          for(var x=0;x < this.state.actions.length;x++){
              const call = this.state.actions[x];
              if(call.idCompany === idCompany) {
                  const s = {width: '20px' , height: '20px'};
                  if (call.subType === 4){
                     phoneInfo.push(
                         <a className="txt-call" href={call.urlRedirect}>
                           <img src={confCurrent.home + "assets/images/icons/call_icon_phone.png"}  className=""  alt="" style={s}/>&nbsp;
                           Llamar
                         </a>
                      );
                 }
              }
          }
          return phoneInfo;
      }


    render() {
        const s = {width: '25px' , height: '25px'};
        //console.log("currentLocation: ",this.state.currentLocation.lat) //output = 18.7583929


        //console.log("this.getZoom(zoom): ",this.getZoom(zoom))

        return (
            <MapLocation
                zoom = {10.5}
                centerAroundCurrentLocation
                google = {this.props.google}
            >
            {this.getMarker()}

            <InfoWindow
                marker={this.state.activeMeMarker}
                visible={this.state.showMeInfo}
                onClose={this.onMeClose}
                >
                <div className="row r-location">
                    <h5>Ubicación actual</h5>
                    <div className="col-sm-6 txt-align">
                        <a href="https://rapidiux.com/facebook" target="_self">
                            <img src={confCurrent.home + "assets/images/icons/ico_fb_check.png" }  className="mx-auto d-block img-social"  alt="" style={s}/> /rapidiux
                        </a>
                    </div>
                    <div className="col-sm-6 txt-align">
                        <a href="https://rapidiux.com/7341589302" target="_self">
                            <img src={confCurrent.home + "assets/images/icons/ico_whats_check.png"}  className="mx-auto d-block img-social"  alt="" style={s}/>734 158 9302
                        </a>
                    </div>
                </div>
            </InfoWindow>
                {this.getCompanyLocation()}
            <InfoWindow
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}
              onClose={this.onClose}>

              <div className="wd-cont">
                <div className="row pl-0 pr-0">

                    <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <h6 className="text-center txt-card">{this.state.selectedPlace.title}</h6>
                    </div>
                    <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 border-card text-center">
                        {this.getPhoneCall(this.state.selectedPlace.name)}
                    </div>

                    <div className="col-4 col-xs-4 col-sm-4 col-md-4 pr-0 pl-0 cointaner-image">
                        {this.getCompanyLogo(this.state.selectedPlace.name)}
                    </div>
                    <div className="col-8 col-xs-8 col-sm-8 col-md-8 pl-0 pr-0">
                        {this.getActionsByDirectory(this.state.selectedPlace.name)}
                        <div  className="listing-footer-info pl-0 pr-0">
                            <div  className="listing-cat pd-social">
                                <div  className="row">
                                    {this.getContactsByDirectory(this.state.selectedPlace.name)}
                                </div>
                            </div>
                        </div>
                        {this.getCompanyRedirect(this.state.selectedPlace.name)}
                    </div>
                </div>
              </div>
            </InfoWindow>
        </MapLocation>
        );
    }
}

export default GoogleApiWrapper({ apiKey: (confCurrent.apiKeyMaps)}) (MapContainer)
